import { GET_VERIFIED_SELLER } from "../action/seller";
import { GET_VERIFIED_SUB_SELLER } from "../action/seller";
import { Sellers } from "../../datamodels/Sellers";
import { SubSellers } from "../../datamodels/SubSeller";

const initialState = {
  verifiedSellerList: new Sellers(),
  verifiedSubSellerList: new SubSellers(),
};

const SellerReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_VERIFIED_SELLER: {
      const { data } = action;
      return {
        ...state,
        verifiedSellerList: data.map(
          (c) =>
            new Sellers(
              c.id,
              c.company_name,
              c.username,
              c.entity_name,
              c.email,
              c.mobile,
              c.kyc_status,
              c.category_type,
              c.cName,
              c.sName,
              c.dName,
              c.productCount,
              c.companyLogo,
              c.companyBanner,
              c.min_order_amount,
              c.account_status,
              c.subSellerStatus
            )
        ),
      };
    }

    case GET_VERIFIED_SUB_SELLER: {
      const { data } = action;
      return {
        ...state,
        verifiedSubSellerList: data.map(
          (c) =>
            new SubSellers(
              c.id,
              c.real_company_name,
              c.username,
              c.entity_name,
              c.email,
              c.mobile,
              c.kyc_status,
              c.category_type,
              c.cName,
              c.sName,
              c.dName,
              c.productCount,
              c.companyLogo,
              c.companyBanner,
              c.min_order_amount,
              c.account_status
            )
        ),
      };
    }

    default:
      return state;
  }
};

export default SellerReducer;
